/**
 * EN/VI switch, rendered into the nav's right-hand slot by /docs and /support.
 *
 * It is deliberately not the same component as the guide's Directory Admin /
 * Members switch: that one is a page control and reads at body size, this one
 * sits in the nav and has to stay out of the way of it.
 */

const LABELS = { en: 'EN', vi: 'VI' };

export default function LocaleToggle({ locale, locales, onChange }) {
  return (
    <div className="locale-toggle" role="group" aria-label="Language">
      {locales.map((code) => (
        <button
          key={code}
          type="button"
          className={`locale-toggle-btn${locale === code ? ' is-active' : ''}`}
          aria-pressed={locale === code}
          onClick={() => onChange(code)}
        >
          {LABELS[code] ?? code.toUpperCase()}
        </button>
      ))}
    </div>
  );
}
